export const colors = {
  systemGreyMedium: '#EAECEE',
};
